import { Sparkles } from "lucide-react";

const ROLE_LABEL = {
  sales_officer: "Sales Officer",
  assistant_manager: "Sales Manager",
  admin_manager: "Admin Manager",
  admin: "Tech Admin",
  director: "Director",
};
import { istHour } from "../../lib/datetime";

function greet() {
  // IST, like every other time on the page. `getHours()` is the viewer's zone,
  // so a rep abroad was greeted "Good evening" at 9 in the morning (RC-8).
  const h = istHour(new Date());
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

export default function GreetingHeader({ user, subtitle, rightSlot }) {
  const firstName = (user?.full_name || "").split(" ")[0] || "there";
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        <span
          className="inline-flex items-center gap-1.5 rounded-full bg-callisto-gold/10 text-callisto-gold px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em]"
          data-testid="dashboard-role-badge"
        >
          <Sparkles size={12} />
          {ROLE_LABEL[user?.role] || user?.role}
        </span>
        <h1
          className="mt-3 text-3xl md:text-4xl font-bold text-callisto-navy tracking-tight"
          data-testid="dashboard-greeting"
        >
          {greet()}, {firstName}.
        </h1>
        {subtitle && <p className="mt-1 text-callisto-body">{subtitle}</p>}
      </div>
      {rightSlot}
    </div>
  );
}
